import { useCssVariable } from '@library/hooks'
import type { FC, SVGProps } from 'react'

import { DEFAULT_HISTOGRAM_PATH } from '../constants'
import css from './Histogram.css'

export const DefaultHistogram: FC<SVGProps<SVGSVGElement>> = props => {
  const { '--color-control-bg-ghost-hover': fill } = useCssVariable(
    '--color-control-bg-ghost-hover',
  )

  return (
    <div className={css.defaultHistogram}>
      <svg {...props}>
        <g>
          <path d={DEFAULT_HISTOGRAM_PATH} fill={fill} />
        </g>
      </svg>
    </div>
  )
}
